(function(){
  function init(root){
    if(!root||root.dataset.isxReady)return;root.dataset.isxReady='1';
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
    var cv=root.querySelector('.snow');
    if(cv&&root.dataset.snow==='1'){
      var ctx=cv.getContext('2d'),W,H,flakes=[];
      var size=function(){W=cv.width=cv.clientWidth;H=cv.height=cv.clientHeight;};size();
      var n=Math.min(120,Math.floor(W/12));
      for(var i=0;i<n;i++)flakes.push({x:Math.random()*W,y:Math.random()*H,r:Math.random()*2.4+.6,s:Math.random()*.8+.3,d:Math.random()*.6-.3});
      var draw=function(){ctx.clearRect(0,0,W,H);ctx.fillStyle='rgba(255,255,255,.75)';
        for(var i=0;i<flakes.length;i++){var f=flakes[i];ctx.globalAlpha=.3+f.r/4;ctx.beginPath();ctx.arc(f.x,f.y,f.r,0,7);ctx.fill();
          if(!reduce){f.y+=f.s;f.x+=f.d;if(f.y>H+5){f.y=-5;f.x=Math.random()*W;}if(f.x>W+5)f.x=-5;if(f.x<-5)f.x=W+5;}}
        ctx.globalAlpha=1;if(!reduce)requestAnimationFrame(draw);};
      draw();var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(size,200);});
    }
    var tilt=root.querySelector('.tilt'),host=root.querySelector('.hero');
    if(tilt&&host&&!reduce&&matchMedia('(hover:hover)').matches){
      host.addEventListener('mousemove',function(e){var r=host.getBoundingClientRect();var px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;tilt.style.transform='rotateY('+(px*18)+'deg) rotateX('+(-py*18)+'deg)';});
      host.addEventListener('mouseleave',function(){tilt.style.transform='rotateY(0) rotateX(0)';});
    }
    var ba=root.querySelector('.ba');
    if(ba){
      var before=ba.querySelector('.before'),div=ba.querySelector('.divider'),knob=ba.querySelector('.knob'),drag=false;
      var setPos=function(p){p=Math.max(2,Math.min(98,p));before.style.clipPath='inset(0 '+(100-p)+'% 0 0)';div.style.left=p+'%';knob.style.left=p+'%';};
      var pos=function(e){var r=ba.getBoundingClientRect(),t=e.touches?e.touches[0]:e;return (t.clientX-r.left)/r.width*100;};
      var move=function(e){if(!drag)return;setPos(pos(e));if(e.cancelable)e.preventDefault();};
      ba.addEventListener('mousedown',function(e){drag=true;setPos(pos(e));});
      ba.addEventListener('touchstart',function(e){drag=true;setPos(pos(e));},{passive:false});
      addEventListener('mousemove',move);ba.addEventListener('touchmove',move,{passive:false});
      addEventListener('mouseup',function(){drag=false;});ba.addEventListener('touchend',function(){drag=false;});
      setPos(50);
    }
    var stats=root.querySelector('.stats');
    if(stats){
      var seen=false,run=function(){if(seen)return;seen=true;
        stats.querySelectorAll('b[data-to]').forEach(function(el){var to=parseFloat(el.dataset.to)||0,suf=el.dataset.suf||'',dec=parseInt(el.dataset.dec||'0',10),t0=null;
          if(reduce){el.textContent=to.toFixed(dec).replace('.',',')+suf;return;}
          var f=function(ts){t0=t0||ts;var k=Math.min(1,(ts-t0)/1300);var v=to*(1-Math.pow(1-k,3));el.textContent=v.toFixed(dec).replace('.',',')+suf;if(k<1)requestAnimationFrame(f);};requestAnimationFrame(f);});};
      if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)run();});},{threshold:.3}).observe(stats);}else run();
    }
  }
  function all(){document.querySelectorAll('[data-isx-root]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-isx-root]');if(r){delete r.dataset.isxReady;init(r);}});
})();
